import ProductPageLayout from "@/components/ProductPageLayout";
import verhokiskot from "@/assets/verhokiskot.png?format=webp&w=800";

const VerhokiskoAsennus = () => (
  <ProductPageLayout title="Verhokisko asennus" metaDescription="Verhokiskojen asennus Keski-Uudellamaalla. Kisko- ja tankojärjestelmät ammattitaidolla." image={verhokiskot} partner="osio" path="/verhokisko-asennus" alternatePath="/en/curtain-track-installation">
    <p className="text-muted-foreground leading-relaxed">
      Laadukas verhokisko on verhoilun perusta. Tarjoamme kattavan asennuspalvelun kisko- ja tankojärjestelmille – 
      kattoon tai seinään kiinnitettävät, yksinkiskoiset ja monikiskoiset ratkaisut.
    </p>
    <h2 className="font-display text-2xl font-bold mt-8 mb-3">Verhokiskotyypit</h2>
    <ul className="space-y-2 text-muted-foreground">
      <li>✓ Kattokiskot – siisti ja moderni ilme</li>
      <li>✓ Seinäkiinnitteiset kiskoat ja tangot</li>
      <li>✓ Moottoriohjatut verhokiskot</li>
      <li>✓ Kaarikiskot erityiskohteisiin</li>
    </ul>
    <p className="text-muted-foreground mt-6 leading-relaxed">
      Asennamme verhokiskot Hyvinkäällä, Järvenpäässä, Keravalla, Mäntsälässä, Nurmijärvellä, Pornaisissa ja Tuusulassa. 
      Katso <a href="https://osio.fi" target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 text-foreground">Osion verhokiskot</a>.
    </p>
  </ProductPageLayout>
);

export default VerhokiskoAsennus;
